import React from "react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import masterServices from "../../Services/masterService";
import Loader from "../../Components/Loader";

export function WarehouseDetail() {
  const history = useHistory();
  const [data] = useState(history.location.state);
  const [loader, setLoader] = useState(true);
  // const [isDetailOpen, setIsDetailOpen] = useState([]);

  let param = new URLSearchParams(history.location.search);
  useEffect(() => {
    onDetail();
    // eslint-disable-next-line
  }, []);

  const onDetail = () => {
    let postData = {
      id: param.get("id"),
    };
    masterServices.get_warehouse_details(postData).then((res) => {
      if (res.status) {
        // setIsDetailOpen(res.data);
        setLoader(false);
      } else {
        history.goBack();
      }
    });
  };
  return (
    <div className="row d-flex justify-content-center">
      <div className="col-8">
        <div className="card p-3">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <table width="100%">
                <tbody>
                  <tr>
                    <td className="py-1">Warehouse Name - </td>
                    <td className="py-1">{data.name}</td>
                  </tr>
                  <tr>
                    <td className="py-1">Short Name - </td>
                    <td className="py-1">{data.short_name}</td>
                  </tr>
                  <tr>
                    <td className="py-1">Adress - </td>
                    <td className="py-1">{data.address}</td>
                  </tr>
                  <tr>
                    <td className="py-1">Ownership - </td>
                    <td className="py-1">{data.ownership}</td>
                  </tr>
                  <tr>
                    <td className="py-1"> Contact Person - </td>
                    <td className="py-1">{data.contact_person}</td>
                  </tr>
                  <tr>
                    <td className="py-1"> Email - </td>
                    <td className="py-1">{data.email}</td>
                  </tr>
                  <tr>
                    <td className="py-1"> Contact Phone - </td>
                    <td className="py-1">{data.contact_phone}</td>
                  </tr>
                  <tr>
                    <td className="py-1"> Remarks - </td>
                    <td className="py-1">{data.remarks}</td>
                  </tr>
                  <tr>
                    <td className="py-1">Status - </td>
                    <td>
                      <span
                        className={
                          "badge rounded-pill font-size-12 pointer" +
                          (data.status === "ACTIVE"
                            ? " bg-success"
                            : " bg-soft-danger")
                        }
                      >
                        {data.status}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <Loader isShow={loader} />
      </div>
    </div>
  );
}
